export default {
  CAPTURE: 'capture',
  CROP: 'crop',
  DEFAULT: 'default',
};
